
import React from 'react';
import { cn } from "@/lib/utils";

interface DashboardIconProps {
  size?: number;
  className?: string;
  isActive?: boolean;
}

const DashboardIcon: React.FC<DashboardIconProps> = ({ 
  size = 20, 
  className,
  isActive = false
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn(
        "transition-colors duration-200",
        isActive ? "text-primary" : "text-muted-foreground",
        className
      )}
    >
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
      <polyline points="9,22 9,12 15,12 15,22"/>
    </svg>
  );
};

export default DashboardIcon;
